import { FormControlLabel, FormGroup, Switch } from '@material-ui/core';
import { ChangeEvent, createElement, FC } from 'react';

import { DynamicSchemaDefinitionToggle } from '../../../../../generated/graphql';
import { ToggleValue } from '../../../../types/DynamicSchema';
import Base from './Base';

type Props = {
  field: DynamicSchemaDefinitionToggle;
  value: ToggleValue;
  onChange: (e: ChangeEvent<HTMLInputElement>, checked: ToggleValue) => void;
  className?: string;
};

const ToggleField: FC<Props> = ({ field, value, onChange, className }) => {
  return (
    <Base field={field} labelPaddingTop={14} className={className}>
      <FormGroup>
        <FormControlLabel
          control={<Switch checked={value} onChange={(e, checked) => onChange(e, checked)} />}
          label={value ? field.checkedControlLabel : field.uncheckedControlLabel}
        />
      </FormGroup>
    </Base>
  );
};

export default ToggleField;
